export default "__VITE_ASSET__DADjZODo__"